<template>
    <div>
        <modal-create v-show="showHideModalCreate"></modal-create>
        <div class="col-md-12" v-show="CHECK_ROLE_CARD(3)">
            <div class="card abtg__default-card abtg__default-card-border ">
                <div class="card-head"  >
                    <header >{{$t('team.title')}} </header>
                    <div class="abtg__header_popover">
                        <popover module="team" content="incomeTeam" color="grey" position="right"></popover>
                    </div>
                    <div class="tools" v-if="CHECK_ROLE_SIDEBAR(100) === true">

                        <a @click="newTeam()" v-if="id >  0" class="btn btn-default      shadow-none abtg__btn-tool">{{$t('team.new_member_btn')}}</a>
                        <a @click="getTeamList()" v-if="id > 0" class="btn btn-default      shadow-none abtg__btn-tool">{{$t('team.remove')}}</a>


                    </div>
                </div>
                <div class="card-body ">

                    <div v-show="showTableReadMode">
                        <div v-for="(u, index) in teamListByMappingId">
                            <p>
                                <strong> {{u.name}}</strong>
                                <span class="abtg__text-abtg"> {{u.profession}}</span><br>
                                <span style="font-weight:normal"><i
                                        class="far fa-envelope"></i> {{u.email}} - <i
                                        class="fas fa-phone"></i> {{u.phone}}<br></span>
                            </p>
                            <hr  class="abtg__hr-narrow">
                        </div>
                    </div>

                    <div v-show="!showTableReadMode" v-for="(u, index) in teamList">
                        <div class="row" >
                            <div class="col-lg-1">
                                <input type="checkbox" name="" v-model="u.checked" @click="addToTeam(u.id)">
                            </div>
                            <div class="col-lg-11">  <strong> {{u.name}}</strong><br>
                                {{u.profession}}</div>

                        </div>
                        <div class="row">
                            <div class="col"> <hr class="abtg__hr-narrow"></div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mixin} from '../../helpers/helper'
    import {roles} from "../../helpers/roles";
    import {createHelpers} from 'vuex-map-fields';
    import modalCreate from '../team/modal_create';
    import Popover from '../commons/popover';

    const {mapFields} = createHelpers({
        getterType: 'team/getField',
        mutationType: 'team/updateField',
    });

    export default {
        mixins: [mixin, roles],
        props: ['page', 'type', 'id'],
        components: {modalCreate, Popover},

        data: function () {
            return {}
        },

        computed: {
            ...mapFields(['teamListByMappingId', 'teamList', 'showTableReadMode', 'noTeam', 'showHideModalCreate']),
            topBarColorBar: function () {
                if (this.type === 1) {
                    return 'card-topline-mapping';
                }
                if (this.type === 3) {
                    return 'card-topline-custom'; // also for custom
                }
                return ' card-topline-auction';
            },

            labelTextColorBar: function () {
                if (this.type === 1) {
                    return 'abtg__label-color-mapping';
                }
                if (this.type === 3) {
                    return 'abtg__label-color-custom'; // also for custom
                }
                return 'abtg__label-color-auction';
            }


        },
        created: function () {
            this.getTeamListByMappingId();
        },
        methods: {
            newTeam: function()
            {
                this.triggerShowHideModalCreate();
                this.$store.dispatch('team/newMember', {fromIncome: true, resourceId: this.page, type: this.type});
            },
            triggerShowHideModalCreate: function () {
                this.$store.dispatch('team/showHideModalCreate');
            },
            getTeamList: function () {
                this.$store.dispatch('team/list', {resourceId: this.id, type: this.type});
            },
            getTeamListByMappingId() {
                this.$store.dispatch('team/listByMapping', {resourceId: this.id, type: this.type});
            },
            editTeam: function () {
                this.$store.dispatch('team/edit', this.page);
            },
            addToTeam: function (id) {
                this.$store.dispatch('team/add', {id: id, resourceId: this.id, type: this.type});
            }
        }
    }
</script>